<template>
  <div class="preloader flex-row justify-content-center align-items-center">
    <div class="spinner-grow text-primary" role="status">
    </div>
    <div class="spinner-grow text-secondary" role="status">
    </div>
    <div class="spinner-grow text-success" role="status">

    </div>
    <div class="spinner-grow text-danger" role="status">

    </div>
    <div class="spinner-grow text-warning" role="status">

    </div>
    <div class="spinner-grow text-info" role="status">

    </div>
  </div>
</template>

<script>
import {GIFT_LIST, USER_INFO, VALID_TOKEN} from "@/stores/actions";
import {GAME_APP} from "../enums/modules/game";
import JwtService from "@/jwt-service";

export default {
  name: "UsingToken",
  created() {
    let vm = this;
    vm.validToken();
  },
  data() {
    return {
      token: this.$route.params.token,
      customerPhone: this.$route.params.customerPhone,
    };
  },
  mounted() {
    let vm = this;
    vm.$root.$on("draw_success", function () {
      vm.getUserInfo();
    });
  },
  methods: {
    validToken() {
      let vm = this;
      vm.$store
          .dispatch(VALID_TOKEN, {token: vm.token})
          .then((res) => {
            if (res && res.status === 200) {
              vm.getUserInfo();
              vm.getGiftList();
              const toRoute = this.$route.query.redirect || "luckyDraw";
              vm.$router.push({
                name: toRoute,
                params: {
                  isAuthenticate: true,
                },
              });
            } else {
              JwtService.destroyToken();
              vm.$router.push({name: "luckyDraw"});
              console.log("Error");
            }
          })
          .catch(() => {
            JwtService.destroyToken();
            vm.$router.push({name: "luckyDraw"});
            console.log("Error");
          });
    },
    getUserInfo(isRetry = 0) {
      let vm = this;
      vm.$store
          .dispatch(USER_INFO, {
            game_id: GAME_APP.ID,
            app_id: GAME_APP.APP_ID,
            customer_id: vm.customerPhone,
          })
          .then((res) => {
            if (res && res.status !== 200) {
              if (isRetry === 0) {
                vm.getUserInfo(1);
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
    },
    getGiftList(isRetry = 0) {
      let vm = this;
      vm.$store
          .dispatch(GIFT_LIST, {game_id: GAME_APP.ID, app_id: GAME_APP.APP_ID})
          .then((res) => {
            if (res && res.status !== 200) {
              if (isRetry === 0) {
                vm.getGiftList(1);
              }
            }
          })
          .catch(() => {
            if (isRetry === 0) {
              vm.getGiftList(1);
            }
          });
    },
  },
};
</script>

<style scoped lang="scss">
.preloader {
  display: -ms-flexbox;
  display: flex;
  background-color: #f4f6f9;
  height: 100vh;
  width: 100%;
  transition: height 0.2s linear;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}

.preloader .spinner-grow {
  margin: 0 4px;
}

.animation__shake {
  -webkit-animation: shake 1.5s infinite;
  animation: shake 1.5s infinite;
}

@-webkit-keyframes shake {
  0% {
    -webkit-transform: translate(2px, 1px) rotate(0);
    transform: translate(2px, 1px) rotate(0);
  }
  10% {
    -webkit-transform: translate(-1px, -2px) rotate(-2deg);
    transform: translate(-1px, -2px) rotate(-2deg);
  }
  20% {
    -webkit-transform: translate(-3px, 0) rotate(3deg);
    transform: translate(-3px, 0) rotate(3deg);
  }
  30% {
    -webkit-transform: translate(0, 2px) rotate(0);
    transform: translate(0, 2px) rotate(0);
  }
  40% {
    -webkit-transform: translate(1px, -1px) rotate(1deg);
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    -webkit-transform: translate(-1px, 2px) rotate(-1deg);
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    -webkit-transform: translate(-3px, 1px) rotate(0);
    transform: translate(-3px, 1px) rotate(0);
  }
  70% {
    -webkit-transform: translate(2px, 1px) rotate(-2deg);
    transform: translate(2px, 1px) rotate(-2deg);
  }
  80% {
    -webkit-transform: translate(-1px, -1px) rotate(4deg);
    transform: translate(-1px, -1px) rotate(4deg);
  }
  90% {
    -webkit-transform: translate(2px, 2px) rotate(0);
    transform: translate(2px, 2px) rotate(0);
  }
  100% {
    -webkit-transform: translate(1px, -2px) rotate(-1deg);
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes shake {

  0% {
    -webkit-transform: translate(2px, 1px) rotate(0);
    transform: translate(2px, 1px) rotate(0);
  }
  10% {
    -webkit-transform: translate(-1px, -2px) rotate(-2deg);
    transform: translate(-1px, -2px) rotate(-2deg);
  }
  20% {
    -webkit-transform: translate(-3px, 0) rotate(3deg);
    transform: translate(-3px, 0) rotate(3deg);
  }
  30% {
    -webkit-transform: translate(0, 2px) rotate(0);
    transform: translate(0, 2px) rotate(0);
  }
  40% {
    -webkit-transform: translate(1px, -1px) rotate(1deg);
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    -webkit-transform: translate(-1px, 2px) rotate(-1deg);
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    -webkit-transform: translate(-3px, 1px) rotate(0);
    transform: translate(-3px, 1px) rotate(0);
  }
  70% {
    -webkit-transform: translate(2px, 1px) rotate(-2deg);
    transform: translate(2px, 1px) rotate(-2deg);
  }
  80% {
    -webkit-transform: translate(-1px, -1px) rotate(4deg);
    transform: translate(-1px, -1px) rotate(4deg);
  }
  90% {
    -webkit-transform: translate(2px, 2px) rotate(0);
    transform: translate(2px, 2px) rotate(0);
  }
  100% {
    -webkit-transform: translate(1px, -2px) rotate(-1deg);
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
